import mixitup from 'mixitup';
import mixitupMultifilter from '../../../libs/gin-tonic/components/mixitup/lib/mixitup-multifilter.js';
import { Component } from '../../../libs/gin-tonic/helpers/compiler';

@Component({ className: 'js-load-more', observe: true })
export class LoadMoreComponent {
	private options = {
		itemSelector: '.js-load-more-item',
		triggerSelector: '.js-load-more-trigger',
		cardIncrease: 6,
		hiddenClass: 'is-hidden',
		activeFilterSelector: '.mixitup-control-active',
		resetSelector: '.js-multi-filter-reset',
		filterSelector: '.js-mixitup-filter',
		optionContainerSelector: '.js-multi-filter-options-container',
		chipContainerSelector: '.js-filter-chip-container',
	};

	private allItems: Element[];
	private filteredItems: Element[];
	private optionContainers: Element[];
	private chipContainer: Element;
	private loadTrigger;
	private resetTrigger;
	private closeIcon: Element;
	private mixer: any;
	private activeHash: string;
	private servicesFilter: HTMLElement;
	private branchFilter: HTMLElement;
	private page = 1;
	private cardIncrease;

	constructor(element: HTMLElement) {
		this.activeHash = '';
		this.servicesFilter = element.querySelector(
			"[data-filter-group='services']"
		);
		this.branchFilter = element.querySelector("[data-filter-group='branches']");
		this.allItems = Array.from(
			element.querySelectorAll(this.options.itemSelector)
		);
		this.loadTrigger = element.querySelector(this.options.triggerSelector);
		this.cardIncrease = parseInt(
			element.getAttribute('data-load-more-increase') ||
				this.options.cardIncrease + ''
		);
		this.optionContainers = Array.from(
			element.querySelectorAll(this.options.optionContainerSelector)
		);
		this.chipContainer = element.querySelector(
			this.options.chipContainerSelector
		);
		this.resetTrigger = element.querySelector(this.options.resetSelector);

		this.filteredItems = this.allItems;
		this.setVisibleItems();
		this.setButtonState();

		this.loadTrigger?.addEventListener('click', () => {
			this.page += 1;
			this.setVisibleItems();
			this.setButtonState();
		});

		// create close icon
		this.closeIcon = document.createElement('span');
		this.closeIcon.classList.add('c-icon');

		const useElem = document.createElementNS(
			'http://www.w3.org/2000/svg',
			'use'
		);
		useElem.setAttributeNS(
			'http://www.w3.org/1999/xlink',
			'xlink:href',
			'/fonts/icons.svg#close'
		);

		const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
		svg.setAttributeNS('http://www.w3.org/2000/svg', 'viewBox', '0 0 24 24');
		svg.appendChild(useElem);

		this.closeIcon.appendChild(svg);

		var uiState = this.deserializeHash();
		
		mixitup.use(mixitupMultifilter);
		this.mixer = mixitup(element, {
			multifilter: {
				enable: true,
			},
			controls: {
				scope: 'local',
			},
			callbacks: {
				onMixEnd: (e) => {
					this.update(e);
				},
				onMixClick: (e) => {
					this.hideItems(this.allItems);
				},
			},
			selectors: {
				target: this.options.itemSelector,
				control: '[data-mixitup-control]',
			},
			animation: {
				enable: false,
			},
		});
		if (uiState) {			
			this.syncMixerWithPreviousUiState(uiState);
		}
	}

	deserializeHash() {
		var hash = window.location.hash.replace(/^#/g, '');
		var obj = null;
		var groups = [];

		if (!hash) return obj;

		obj = {};
		groups = hash.split('&');

		groups.forEach(function (group) {
			var pair = group.split('=');
			var groupName = pair[0];

			obj[groupName] = pair[1].split(',');
		});

		return obj;
	}

	serializeUiState(uiState) {
		var output = '';

		for (var key in uiState) {
			var values = uiState[key];

			if (!values.length) continue;

			output += key + '=';
			output += values.join(',');
			output += '&';
		}

		output = output.replace(/&$/g, '');

		return output;
	}

	getUiState() {		
		if (this.servicesFilter && this.branchFilter == null) {
			return {
				services: this.mixer
					.getFilterGroupSelectors('services')
					.map(this.getValueFromSelector),
			};
		} else if (this.servicesFilter == null && this.branchFilter) {
			return {
				branches: this.mixer
					.getFilterGroupSelectors('branches')
					.map(this.getValueFromSelector),
			};
		} else if (this.servicesFilter && this.branchFilter) {
			return {
				services: this.mixer
					.getFilterGroupSelectors('services')
					.map(this.getValueFromSelector),
				branches: this.mixer
					.getFilterGroupSelectors('branches')
					.map(this.getValueFromSelector),
			};
		}
	}

	update(e) {
		if (this.servicesFilter || this.branchFilter) {
			this.setHash(e);
		}		
		this.filteredItems = e.show;
		this.hideItems(e.hide);
		this.setVisibleItems();
		this.setButtonState();
		this.setBadgesState();
		this.setResetState();
	}
	setHash(state) {
		var selector = state.activeFilter.selector;
		var uiState = this.getUiState();
		var newHash = '#' + this.serializeUiState(uiState);
		if (
			selector === this.options.itemSelector &&
			window.location.href.indexOf('#') > -1
		) {
			this.activeHash = '';
			history.replaceState(null, document.title, window.location.pathname);
		} else if (
			newHash !== window.location.hash &&
			selector !== this.options.itemSelector
		) {
			this.activeHash = newHash;
			history.replaceState(
				null,
				document.title,
				window.location.pathname + newHash
			);
		}
	}

	syncMixerWithPreviousUiState(uiState) {
		if (this.servicesFilter) {
			var services = uiState && uiState.services ? uiState.services : [];

			this.mixer.setFilterGroupSelectors(
				'services',
				services.map(this.getSelectorFromValue)
			);
		}
		if (this.branchFilter) {
			var branches = uiState && uiState.branches ? uiState.branches : [];

			this.mixer.setFilterGroupSelectors(
				'branches',
				branches.map(this.getSelectorFromValue)
			);
		}
		return this.mixer.parseFilterGroups();
	}

	getValueFromSelector(selector) {
		return selector.replace(/^./, '');
	}

	getSelectorFromValue(value) {
		return '.' + value;
	}

	setBadgesState() {
		if (this.chipContainer != null) {
			this.chipContainer.innerHTML = '';

			this.optionContainers.forEach((options) => {
				const filters = options.querySelectorAll<HTMLElement>(
					this.options.activeFilterSelector
				);
				filters.forEach((filter: HTMLElement) => {
					this.chipContainer.appendChild(this.createChip(filter));
				});
			});
		}
	}

	createChip(filter: HTMLElement) {
		const chip = document.createElement('a');
		chip.classList.add('c-filter__chips__item', 'c-text');
		chip.innerHTML = filter.innerHTML;
		chip.prepend(this.closeIcon.cloneNode(true));
		chip.addEventListener('click', () => {
			filter.click();
		});
		return chip;
	}

	setVisibleItems(showAll = false) {
		const maxVal = showAll
			? this.filteredItems.length
			: this.cardIncrease * this.page;

		const visibleList = this.filteredItems.slice(0, maxVal);
		visibleList.forEach((item) => {
			item.classList.remove(this.options.hiddenClass);
		});

		const hiddenList = this.filteredItems.slice(maxVal);
		hiddenList.forEach((item) => {
			item.classList.add(this.options.hiddenClass);
		});
	}

	hideItems(list = []) {
		list.forEach((item) => {
			item.classList.add(this.options.hiddenClass);
		});
	}

	setResetState() {
		this.resetTrigger?.classList.toggle(
			'd-none',
			this.chipContainer?.childElementCount == 0
		);
	}

	setButtonState() {
		this.loadTrigger?.classList.toggle(
			'd-none',
			this.filteredItems.length <= this.cardIncrease * this.page
		);
	}
}
